import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { formatFilterLabelText } from "./formatFilterLabel";

interface Props {
    filters: Pick<FiltersTypes, "ruleStatuses">;
}

export const RulesStatusFilterLabel: React.FC<Props> = ({
    filters: { ruleStatuses },
}) => <>{formatFilterLabelText(ruleStatuses ?? [], "Statuses") ?? "All"}</>;
